var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6071 39.0235H15.9643C7.09523 39.0235 3.54761 35.4759 3.54761 26.6069V15.964C3.54761 7.09498 7.09523 3.54736 15.9643 3.54736H26.6071C35.4762 3.54736 39.0238 7.09498 39.0238 15.964V26.6069C39.0238 35.4759 35.4762 39.0235 26.6071 39.0235Z",
    fill: "#4C1EA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8334 16.4966V21.6407H29.4453C29.8001 21.6407 29.9774 21.9954 29.9774 22.3502L29.2679 25.7204C29.2679 25.8978 28.9132 26.0752 28.7358 26.0752H24.8334V39.024H19.512V26.2526H16.4965C16.1417 26.2526 15.9644 26.0752 15.9644 25.7204V22.3502C15.9644 21.9954 16.1417 21.8181 16.4965 21.8181H19.512V15.9645C19.512 12.949 21.8179 10.6431 24.8334 10.6431H29.6227C29.9774 10.6431 30.1548 10.8204 30.1548 11.1752V15.4324C30.1548 15.7871 29.9774 15.9645 29.6227 15.9645H25.3655C25.0108 15.9645 24.8334 16.1419 24.8334 16.4966Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a8f944138bc390171d0badc6e41eab0c.svg";
export { ForwardRef as ReactComponent };